import {useQuery, UseQueryResult} from "react-query";
import {getAllRoleNiveau} from "./roleNiveau.services";


export const useGetRoleNiveaux=():UseQueryResult<RoleNiveau[], Error>=>{
    return useQuery<RoleNiveau[], Error>(["roles_niveau"], getAllRoleNiveau, {
        refetchOnWindowFocus:false,
    })
}